import HomophonesPractice from "../../components/ClassOne/English/HomophonesPractice";
import JumbledWords from "../../components/ClassOne/English/JumbledWords";
import Nouns from "../../components/ClassOne/English/Nouns";
import SpellBee from "../../components/ClassOne/English/SpellBee";
import SpellingMCQ from "../../components/ClassOne/English/SpellingMCQ";
import NounsMenu from "../../menus/ClassOne/Nouns";
import JumbledWordsMenu from "../../menus/ClassOne/JumbledWords";
import PunctuationMenu from "../../menus/ClassOne/Punctuation";
import ContractionsMenu from "../../menus/ClassOne/Contractions";
import SimpleTensesMenu from "../../menus/ClassOne/SimpleTenses";
import PronounsMenu from "../../menus/ClassOne/Pronouns";
import VerbsMenu from "../../menus/ClassOne/Verbs";
import AdverbsMenu from "../../menus/ClassOne/Adverbs";
import GenderNumberMenu from "../../menus/ClassOne/GenderNumber";
import OppositeWordsWorksheet from "../../components/ClassOne/English/OppositeWordsWorksheet";
import ReadingComprehensionWorksheet from "../../components/ClassOne/English/ReadingComprehensionWorksheet";
import Articles from "../../components/ClassOne/English/Articles";
import Punctuation from "../../components/ClassOne/English/Punctuation";
import Contractions from "../../components/ClassOne/English/Contractions";
import SimpleTenses from "../../components/ClassOne/English/SimpleTenses";
import RhymingWordsWorksheet from "../../components/ClassOne/English/RhymingWords";
import Pronouns from "../../components/ClassOne/English/Pronouns";
import Verbs from "../../components/ClassOne/English/Verbs";
import Adjectives from "../../components/ClassOne/English/Adjectives";
import Conjunctions from "../../components/ClassOne/English/Conjunctions";
import Prepositions from "../../components/ClassOne/English/Prepositions";
import Adverbs from "../../components/ClassOne/English/Adverbs";
import GenderNumber from "../../components/ClassOne/English/GenderNumber";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/english/nouns", title: "Nouns", component: Nouns, subMenu: NounsMenu },
    { url: "/class-one/english/pronouns", title: "Pronouns", component: Pronouns, subMenu: PronounsMenu },
    { url: "/class-one/english/verbs", title: "Verbs", component: Verbs, subMenu: VerbsMenu },
    { url: "/class-one/english/adverbs", title: "Adverbs", component: Adverbs, subMenu: AdverbsMenu},
    { url: "/class-one/english/adjectives", title: "Adjectives", component: Adjectives },
    { url: "/class-one/english/articles", title: "Articles", component: Articles },
    { url: "/class-one/english/prepositions", title: "Prepositions", component: Prepositions },
    { url: "/class-one/english/conjunction", title: "Conjunctions", component: Conjunctions },
    { url: "/class-one/english/contractions", title: "Contractions", component: Contractions, subMenu: ContractionsMenu },
    { url: "/class-one/english/rhyming-words", title: "Rhyming Words", component: RhymingWordsWorksheet },
    { url: "/class-one/english/punctuation", title: "Punctuation", component: Punctuation, subMenu: PunctuationMenu},
    { url: "/class-one/english/simple-tenses", title: "Simple Tenses", component: SimpleTenses, subMenu: SimpleTensesMenu },
    //{ url: "/class-one/english/jumbled-words", title: "Jumbled Words", component: JumbledWords, subMenu: JumbledWordsMenu },
    { url: "/class-one/english/reading-comprehension", title: "Reading Comprehension", component: ReadingComprehensionWorksheet },
    { url: "/class-one/english/gender-numbers", title: "Gender & Numbers", component: GenderNumber, subMenu: GenderNumberMenu },
    { url: "/class-one/english/spell-bee", title: "Spell-Bee", component: SpellingMCQ},
    { url: "/class-one/english/homophones", title: "Homophones", component: HomophonesPractice},
    { url: "/class-one/english/opposite-words", title: "Opposite Words", component: OppositeWordsWorksheet },
];


export default topics;